module.exports = __webpack_public_path__ + "img/Tacco_e_Intertacco_SX.7660fcb1.png";